'use strict';

import React from 'react';
import { createRoot } from 'react-dom/client';
import LoadingBlock from '../components/loadingBlock/index';

class PreLoader {
    constructor(params) {
        this.eventEmitter = params.eventEmitter;
        this.root = null;
    }

    initLoader() {
        this.eventEmitter.on('showLoader', () => {
            let loaderNode = document.querySelector('.loader-container');
            if (!loaderNode) {
                let node = document.createElement('div');
                node.className = 'loader-container';
                document.body.appendChild(node);

                // Рендерим React компонент
                this.root = createRoot(node);
                this.root.render(React.createElement(LoadingBlock));
            }
        });

        this.eventEmitter.on('hideLoader', () => {
            let loaderNode = document.querySelector('.loader-container');
            if (loaderNode instanceof HTMLElement) {
                // Размонтируем React компонент
                if (this.root) {
                    this.root.unmount();
                    this.root = null;
                }
                loaderNode.parentNode.removeChild(loaderNode);
            }
        });
    }
}


export default PreLoader;